import { Component, Input } from "@angular/core";
import { PreviewItemComponent } from "../preview-item.component";

@Component({
    selector: "preview-item-context-normal",
    imports: [],
    templateUrl: "./preview-item-context-menu-normal.component.html"
})
export class PreviewItemContextMenuNormal {
    @Input({ required: true }) previewItem!: PreviewItemComponent;

    public getCount(): number {
        return this.previewItem.previewItem.collected?.count ?? 0;
    }

    public onIncrement(): void {
        this.previewItem.adjustCount(1, 0, 0);
    }

    public onDecrement(): void {
        this.previewItem.adjustCount(-1, 0, 0);
    }

    public onChange(event: Event): void {
        var target = (event.target as HTMLInputElement);
        this.previewItem.setNormalCount(Number.parseInt(target.value));
        target.value = `${this.getCount()}`;
    }
}